import React, { useEffect } from "react";
import "./Vip_all_history.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { GETVipBenifitHistory } from "../../features/auth/Slice";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";
import { formatNotifDate } from "../../utils/common";

function Vip_all_history() {
  const HISTORY_DATA = [
    {
      id: 1,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:43:37",
      value: [{ val: "265 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 2,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:38:24",
      value: [{ val: "140 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 3,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-04-03 11:03:36",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 4,
      title: "Level maintenance",
      subtitle: "Completion of level maintenance conditions [100% Completed]",
      date: "2026-04-01 03:59:15",
      value: [{ val: "0 EXP", type: "exp" }],
      titleColor: "#e74c3c",
    },
    {
      id: 5,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-03-07 23:23:50",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 6,
      title: "VIP level",
      subtitle: "VIP level upgraded to [VIP3]",
      date: "2026-03-07 23:23:50",
      value: [], // No value shown on the right for this item in the image
      titleColor: "#e2984e", // Golden/Tan color for Level Up
    },

    {
      id: 1,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:43:37",
      value: [{ val: "265 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 2,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:38:24",
      value: [{ val: "140 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 3,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-04-03 11:03:36",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 4,
      title: "Level maintenance",
      subtitle: "Completion of level maintenance conditions [100% Completed]",
      date: "2026-04-01 03:59:15",
      value: [{ val: "0 EXP", type: "exp" }],
      titleColor: "#e74c3c",
    },
    {
      id: 5,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-03-07 23:23:50",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 6,
      title: "VIP level",
      subtitle: "VIP level upgraded to [VIP3]",
      date: "2026-03-07 23:23:50",
      value: [], // No value shown on the right for this item in the image
      titleColor: "#e2984e", // Golden/Tan color for Level Up
    },

    {
      id: 1,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:43:37",
      value: [{ val: "265 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 2,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:38:24",
      value: [{ val: "140 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 3,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-04-03 11:03:36",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 4,
      title: "Level maintenance",
      subtitle: "Completion of level maintenance conditions [100% Completed]",
      date: "2026-04-01 03:59:15",
      value: [{ val: "0 EXP", type: "exp" }],
      titleColor: "#e74c3c",
    },
    {
      id: 5,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-03-07 23:23:50",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 6,
      title: "VIP level",
      subtitle: "VIP level upgraded to [VIP3]",
      date: "2026-03-07 23:23:50",
      value: [], // No value shown on the right for this item in the image
      titleColor: "#e2984e", // Golden/Tan color for Level Up
    },

    {
      id: 1,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:43:37",
      value: [{ val: "265 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 2,
      title: "Experience Bonus",
      subtitle: "Betting EXP",
      date: "2026-04-03 16:38:24",
      value: [{ val: "140 EXP", type: "exp" }],
      titleColor: "#3d77e8",
    },
    {
      id: 3,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-04-03 11:03:36",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 4,
      title: "Level maintenance",
      subtitle: "Completion of level maintenance conditions [100% Completed]",
      date: "2026-04-01 03:59:15",
      value: [{ val: "0 EXP", type: "exp" }],
      titleColor: "#e74c3c",
    },
    {
      id: 5,
      title: "Successfully received",
      subtitle: "Successfully received [Monthly bonus]",
      date: "2026-03-07 23:23:50",
      value: [
        { val: "290", type: "yellow_coin" },
        { val: "0", type: "red_heart" },
      ],
      titleColor: "#27ae60",
    },
    {
      id: 6,
      title: "VIP level",
      subtitle: "VIP level upgraded to [VIP3]",
      date: "2026-03-07 23:23:50",
      value: [], // No value shown on the right for this item in the image
      titleColor: "#e2984e", // Golden/Tan color for Level Up
    },
  ];



  const dispatch = useDispatch()

  const VipBenifitHistory = useSelector((state) => state.auth.data);
  console.log({ VipBenifitHistory });


  const fetch = async (page = 1) => {
    await dispatch(GETVipBenifitHistory({ page }))
  }

  useEffect(() => { fetch(1) }, [dispatch]);


  const handlePageChange = async (page) => {
    fetch(page)
  };



  return (
    <>
      <section className="Rebate_Ratio">
        <Common_white_header headingText={"Vip History"} />
        <div className="container">
          <div className="VipTabHistory">
            {VipBenifitHistory?.data?.length > 0 ? VipBenifitHistory?.data?.map((item) => {
              const values = [];
              let titleColor = "#e2984e"

              if (item.amount) {
                values.push({ type: "yellow_coin", val: item.amount });
                titleColor = "#27ae60"
              }

              if (item.exp) {
                values.push({ type: "exp", val: item.exp });
                titleColor = "#3d77e8"
              }

              return (
                <div key={item.id} className="history_card">
                  <div className="history_info">
                    <h4 style={{ color: titleColor }}>
                      {item.name || ""}
                    </h4>
                    <p className="history_sub">{item.remark || ""}</p>
                    <span className="history_time">
                      {formatNotifDate(item.createdAt)}
                    </span>
                  </div>

                  <div className="history_value">
                    {values.map((v, idx) => {
                      if (v.type === "yellow_coin") {
                        return (
                          <div key={idx} className="bonus_box yellow_bonus_box">
                            <span className="coin_icon">🪙</span> {v.val}
                          </div>
                        );
                      }

                      if (v.type === "exp") {
                        return (
                          <div key={idx} className="bonus_box">
                            EXP {v.val}
                          </div>
                        );
                      }

                      return (
                        <span key={idx} className="exp_amt">
                          {v.val}
                        </span>
                      );
                    })}
                  </div>
                </div>
              );
            }) :
              <No_data />
            }
          </div>

          {VipBenifitHistory?.total_pages > 1 &&
            <CustomPagination currentPage={VipBenifitHistory?.current_page}
              totalPages={VipBenifitHistory?.total_pages}
              handlePageChange={handlePageChange} />}
        </div>
      </section>
    </>
  );
}

export default Vip_all_history;
